import type { FC } from 'react'
import { 
  Badge,
  Card,
  CardBody,
  Text,
  Image,
  Skeleton,
  Button,
  Stack,
  Link,
  Box
} from "@chakra-ui/react"
import { BuyButton } from '~/components/BuyButton';
import {Link as RouterLink} from 'react-router-dom';
import { GoToProductButton } from '~/components/GoToProductButon';

type TPriceInfo = {
  regularPrice: string;
  discountPrice?: string;
}

const Price: FC<{priceInfo: TPriceInfo}> = ({priceInfo}) => {
  if (priceInfo.discountPrice) {
    return (
      <Text>Cena: <s>{priceInfo.regularPrice}</s>&nbsp;<Box fontWeight={'bold'} as='span' color={'primary.500'}>{priceInfo.discountPrice}</Box></Text>  
      )
  }
  return (
    <Text>Cena: <b>{priceInfo.regularPrice}</b></Text>
  )
}

type TProductBookCard = {
  type: 'book',
  id: string;
  slugUrl: string;
  buyLink?: string;
  images: {
    src: string;
    alt: string;
    type?: 'product-cover'
  }[],
  productInfo: {
    title: string;
    author: string;
    variant: 'ebook' | 'książka' | 'ebook + książka';
  },
  priceInfo: TPriceInfo
}

export const ProductBookCard: FC<{product: TProductBookCard; priority: 'high' | 'low'}> = ({ product, priority }) => {
  const coverImagePath = product.images.find(img => {
    return img.type === 'product-cover'
  })?.src || product.images[0].src
  const productPagePath = `/ksiazka/${product.slugUrl}`
  return (
    <Card width={'xs'} shadow={'none'} mb={{base: 6, md: 2}} bgColor={'none'} >
      <Link as={RouterLink} to={productPagePath} transition={'transform 250ms ease-in-out'} _hover={{
          transform: 'perspective(100vw) rotateY(5deg) rotateX(-3deg)',
          textDecoration: 'none'
        }}>
      <CardBody pb={0} >
        <Image
          loading={priority === 'high' ? "eager" : "lazy"}
          fetchPriority={priority}
          borderRadius={4}
          height={'400px'}
          src={coverImagePath}
          alt={product.images[0].alt} 
        />
      </CardBody>
      <CardBody>
        <Text as='h4' fontSize='2xl'>{product.productInfo.title}, {product.productInfo.author}</Text>
        <Price priceInfo={product.priceInfo} />
        <Text>Wersja: <Badge colorScheme='primary' color={'white'}>{product.productInfo.variant}</Badge></Text>
      </CardBody>
      </Link>
      <Stack direction={{ base: 'column' }} justifyContent={'space-evenly'} px={4}>
        <BuyButton productBuyPath={product.buyLink} />
        <GoToProductButton productPagePath={productPagePath} />
      </Stack>
    </Card>
  )
}

export const ProductBookCardSkeleton: FC = () => {
  return (
    <Card shadow={'none'} mb={{base: 6, md: 2}} bgColor={'none'}>
      <CardBody textAlign={'center'} pb={0} >
        <Skeleton speed={0} borderRadius={4} height={'400px'} />
        <Button isDisabled position={'absolute'} top={'50%'} left={'50%'} transform={'translate(-50%, -50%)'}>Pokaże wszystkie</Button>
      </CardBody>
      <CardBody>
        <Skeleton speed={0} my={2} py={0} height='24px' />
        <Skeleton speed={0} my={1} height='18px' />
        <Skeleton speed={0} my={1} height='18px' />
      </CardBody>
      <Stack direction={{ base: 'column' }} justifyContent={'space-evenly'}>
        <Skeleton borderRadius={6} width={{base: '100%'}}
        padding={{base: 6, md: 4}} speed={0} height='40px' />
        <Skeleton borderRadius={6} width={{base: '100%'}}
        padding={{base: 6, md: 4}} speed={0} height='40px' />
      </Stack>
    </Card>
  )
}